// @ts-nocheck
import { Fragment, useEffect, useRef, useState, useCallback } from "react";
import { useNavigationStore } from "src/store/navigationStore";
import { useExplorationStore } from "@/store/explorationStore";

// import { Canvas, useFrame, RootState } from "@react-three/fiber";
// import { Splat, OrbitControls, Line } from "@react-three/drei";
import { useHexagonSize } from "src/hooks/useHexagonSize";

import { interpolateVector3Array } from "src/utils/navigation";
import {
  Vector3Point,
  Point3D,
  filterStraightLinePoints,
} from "src/utils/three";

import { CoordinateUtil } from "src/utils/CoordinateUtil";

import {
  getVenueModelConfigByVenueCode,
  getAltitudeByFloorName,
  getBaseUrl,
  getVenueIdByVenueCode,
  getAllFloorMapAlignByVenueId,
  getMapSettingByVenueCode,
  getModelConfigMapByLcMapId,
  findMapAlignWithLcMapId,
} from "src/utils/map-util";

import * as pc from "playcanvas";
import {
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  interpolateVector3,
} from "src/utils/game";
import { OrbitControls } from "@playcanvas/react/scripts";
import { useMaterial, useAppEvent } from "@playcanvas/react/hooks";
import { Application, Entity } from "@playcanvas/react";
import {
  Render,
  Camera,
  Light,
  Environment,
} from "@playcanvas/react/components";
import { useEnvAtlas } from "@playcanvas/react/hooks";
import { GSplat, Script } from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";
import {
  useTexture,
  useApp,
  useSplat,
  useModel,
} from "@playcanvas/react/hooks";
import { Gltf } from "@playcanvas/react";

import { GlbModel } from "@/components/playcanvas/playcanvasComponents";

export default function ExplorationTopView() {
  const SCALE_BASE = 1500;
  const setIsDisplayTopViewScene = useExplorationStore(
    (state) => state.setIsDisplayTopViewScene,
  );
  const [isUnmounting, setIsUnmounting] = useState();
  const [mapSettingState, setMapSettingState] = useState();
  const mapSettingRef = useRef();

  const latestProgressRef = useRef<number>(0);

  const currentLcMapIdRef = useRef("");

  const latestNavigationPositionArrayRef = useRef<pc.Vec3[]>([]);

  const latestCameraPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  const latestCameraLookingPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));

  const latestAllFloorMapAlignRef = useRef<IMapAlign>(
    getAllFloorMapAlignByVenueId(0),
  );

  const { HEX_WIDTH_INNER, HEX_HEIGHT_INNER } = useHexagonSize();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 769);
    };

    checkIsMobile(); // Check on initial render
    window.addEventListener("resize", checkIsMobile);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  useEffect(() => {
    console.log("mounting");
    setIsUnmounting(false);
    setIsDisplayTopViewScene(true);
    return () => {
      console.log("unmounting");
      setIsUnmounting(true);
    };
  }, []);

  const topViewModelAllRef = useRef({});

  const DataController = () => {
    const cameraPosition = useExplorationStore((state) => state.cameraPosition);
    const cameraLookingPosition = useExplorationStore(
      (state) => state.cameraLookingPosition,
    );
    useEffect(() => {
      latestCameraPositionRef.current = cameraPosition;
      latestCameraLookingPositionRef.current = cameraLookingPosition;
    }, [cameraPosition, cameraLookingPosition]);

    const currentVenue = useExplorationStore((state) => state.currentVenue);
    const currentLcMapId = useExplorationStore((state) => state.currentLcMapId);
    useEffect(() => {
      currentLcMapIdRef.current = currentLcMapId;
      if (
        currentVenue == null ||
        currentVenue == "" ||
        currentLcMapId == null ||
        currentLcMapId == ""
      ) {
        return;
      }

      const mapSetting = getMapSettingByVenueCode(currentVenue);
      setMapSettingState(mapSetting);
      mapSettingRef.current = mapSetting;
      const venueModelConfig = mapSetting.modelConfig;
      const modelConfigMap = getModelConfigMapByLcMapId(
        venueModelConfig,
        currentLcMapId,
      );
      const altitude = modelConfigMap.altitude;
    }, [currentVenue, currentLcMapId]);

    return <></>;
  };

  const VenueSogs = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const floorSogParentRef = useRef();
    const allFloorSog = mapSettingState.modelConfig.floor.map((floor, i) => {
      if (floor.sog) {
        return (
          <Entity key={floor.lcMapId}>
            <SogSplat
              url={baseUrl + mapSettingState.modelConfig.folderPath + floor.sog}
              lcMapId={floor.lcMapId}
            ></SogSplat>
          </Entity>
        );
      } else {
        return <Fragment key={floor.lcMapId}></Fragment>;
      }
    });
    return <Entity ref={floorSogParentRef}>{allFloorSog}</Entity>;
  };

  const FloorMeshs = () => {
    const app = useApp();
    const baseUrl = getBaseUrl();
    const floorMeshParentRef = useRef();
    const allFloorMesh = mapSettingState.modelConfig.floor.map((floor, i) => {
      if (floor.mesh) {
        return (
          <Entity key={floor.lcMapId}>
            <FloorMeshModel
              lcMapId={floor.lcMapId}
              meshUrl={
                baseUrl +
                mapSettingState.modelConfig.folderPath +
                floor.mesh.url
              }
              meshPosition={floor.mesh.position}
              meshRotationAngle={floor.mesh.rotationAngle}
              meshScale={floor.mesh.scale}
              meshColor={floor.mesh.color ?? "#FFFFFF"}
              meshOpacity={floor.mesh.opacity ?? 1}
            />
          </Entity>
        );
      } else {
        return <Fragment key={floor.lcMapId}></Fragment>;
      }
    });
    return <Entity ref={floorMeshParentRef}>{allFloorMesh}</Entity>;
  };

  const FloorMeshModel = ({
    lcMapId,
    meshUrl,
    meshPosition,
    meshRotationAngle,
    meshScale,
    meshColor,
    meshOpacity,
  }: {
    lcMapId: string;
    meshUrl: string;
    meshPosition: number[];
    meshRotationAngle: number[];
    meshScale: number[];
    meshColor: string;
    meshOpacity: number;
  }) => {
    const meshEntityRef = useRef();
    const { asset: meshAsset } = useModel(meshUrl);
    const color = hexToRgbArray(meshColor);

    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      console.log("change material");
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            // const currentMaterial = meshInstance.material;
            // const material = currentMaterial.clone();
            const material = meshInstance.material;
            meshInstance.material = material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1.0;
              material.emissive = new pc.Color(color[0], color[1], color[2]);
              material.useLighting = false;
              material.update();
            }
          });
        }
      });
    };
    useEffect(() => {
      if (meshAsset && meshEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(meshEntityRef.current);
        });
      }
    }, [meshAsset]);

    return (
      <Entity
        ref={meshEntityRef}
        position={[
          meshPosition[0] / mapSettingState.modelConfig.scaleFactor,
          meshPosition[1] / mapSettingState.modelConfig.scaleFactor,
          meshPosition[2] / mapSettingState.modelConfig.scaleFactor,
        ]}
        rotation={meshRotationAngle}
        scale={[
          meshScale[0] / mapSettingState.modelConfig.scaleFactor,
          meshScale[1] / mapSettingState.modelConfig.scaleFactor,
          meshScale[2] / mapSettingState.modelConfig.scaleFactor,
        ]}
      >
        <Render type="asset" asset={meshAsset} />
      </Entity>
    );
  };

  const SogSplat = ({ url, lcMapId }: { url: string; lcMapId: string }) => {
    const app = useApp();
    const floorRef = useRef();

    let lastUpdate = 0;
    const UPDATE_INTERVAL = 1 / 1;

    const handleUpdate = useCallback((dt: number) => {
      lastUpdate += dt;
      if (lastUpdate >= UPDATE_INTERVAL) {
        updateFrame();
        lastUpdate = 0;
      }
    }, []);
    useAppEvent("update", handleUpdate);

    const updateFrame = (dt: number) => {
      if (currentLcMapIdRef.current != null && floorRef.current != null) {
        if (currentLcMapIdRef.current == lcMapId) {
          floorRef.current.enabled = true;
        } else {
          floorRef.current.enabled = false;
        }
      }
    };

    const { asset } = useSplat(url);
    return (
      <Entity
        enabled={false}
        ref={floorRef}
        rotation={[180, 0, 0]}
        position={[0, 0, 0]}
        scale={[
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
          1 / mapSettingState.modelConfig.scaleFactor,
        ]}
      >
        <GSplat asset={asset} />
      </Entity>
    );
  };

  const MainObject = () => {
    const app = useApp();
    const mainObjectEntityRef = useRef();
    const cameraScriptRef = useRef();
    const cameraRef = useRef();
    let _localProgress;
    let finalCameraPosition = new pc.Vec3(0, 0, 0);
    let finalCameraLookingPosition = new pc.Vec3(0, 0, 0);

    let _localCameraPosition;

    let lastUpdate = 0;
    const UPDATE_INTERVAL = 1 / 10;
    const handleUpdate = useCallback((dt: number) => {
      lastUpdate += dt;
      if (lastUpdate >= UPDATE_INTERVAL) {
        updateFrame();
        lastUpdate = 0;
      }
    }, []);
    const updateFrame = () => {
      if (!cameraScriptRef.current) {
        return;
      }

      let isCameraPositionUpdated =
        _localCameraPosition != latestCameraPositionRef.current;
      _localCameraPosition = latestCameraPositionRef.current;

      const mapAlign = findMapAlignWithLcMapId(
        mapSettingRef.current.floorAlignment,
        currentLcMapIdRef.current,
      );

      // let scaleFactor = 1;
      // if(mapSettingRef.current.alignmentSetting == "mesh_alignment"){
      //   scaleFactor = 100;
      // }
      // else{
      //   scaleFactor = 20 + mapSettingRef.current.modelConfig.topAltitude / (SCALE_BASE / mapAlign.scale);
      // }

      const scaleFactor =
        20 +
        mapSettingRef.current.modelConfig.topAltitude /
          (SCALE_BASE / mapAlign.scale);

      finalCameraPosition = new pc.Vec3(
        _localCameraPosition.x,
        // _localCameraPosition.y + 1000 / mapSettingState.modelConfig.scaleFactor,
        _localCameraPosition.y + scaleFactor,
        _localCameraPosition.z,
      );

      finalCameraLookingPosition = new pc.Vec3(
        _localCameraPosition.x,
        _localCameraPosition.y,
        _localCameraPosition.z - 0.001,
      );

      cameraScriptRef.current.reset(
        finalCameraLookingPosition,
        finalCameraPosition,
      );
    };
    useAppEvent("update", handleUpdate);

    useEffect(() => {
      const defaultCameraLookingPosition = new pc.Vec3(
        mapSettingRef.current.modelConfig.defaultPosition[0] /
          mapSettingRef.current.modelConfig.scaleFactor,
        mapSettingRef.current.modelConfig.defaultPosition[1] /
          mapSettingRef.current.modelConfig.scaleFactor,
        mapSettingRef.current.modelConfig.defaultPosition[2] /
          mapSettingRef.current.modelConfig.scaleFactor,
      );
      const defaultPosition = new pc.Vec3(
        mapSettingRef.current.modelConfig.defaultPosition[0] /
          mapSettingRef.current.modelConfig.scaleFactor,
        mapSettingRef.current.modelConfig.defaultPosition[1] /
          mapSettingRef.current.modelConfig.scaleFactor +
          50,
        mapSettingRef.current.modelConfig.defaultPosition[2] /
          mapSettingRef.current.modelConfig.scaleFactor,
      );
      mainObjectEntityRef.current.setPosition(defaultPosition);
      cameraScriptRef.current.reset(
        defaultCameraLookingPosition,
        defaultPosition,
      );
    }, []);

    return (
      <Entity ref={mainObjectEntityRef}>
        <Entity>
          <Camera clearColor="#000000" />
          <Script
            ref={cameraScriptRef}
            script={CameraControls}
            enableFly={false}
          />
        </Entity>
      </Entity>
    );
  };

  const EachFloorTopViewModel = ({ lcMapId, url, floorSize, yAxis }) => {
    const app = useApp();
    const isDisplayUI = useExplorationStore((state) => state.isDisplayUI);
    const currentLcMapId = useExplorationStore((state) => state.currentLcMapId);

    const mapAlign = findMapAlignWithLcMapId(
      mapSettingState.floorAlignment,
      lcMapId,
    );
    const scaleFactor = SCALE_BASE / mapAlign.scale;

    let topviewPosition = [0, 0, 0];
    if (mapSettingState.alignmentSetting == "mesh_alignment") {
      const cu = new CoordinateUtil(mapAlign);
      const { x, y } = cu.latLngToXY([
        mapAlign.center.lng,
        mapAlign.center.lat,
      ]);
      topviewPosition = [-x / scaleFactor, yAxis / scaleFactor, y / scaleFactor];
    } else {
      topviewPosition = [
        -floorSize.width / 2 / scaleFactor,
        yAxis / scaleFactor,
        -floorSize.height / 2 / scaleFactor,
      ];
    }

    return (
      <Entity
        // ref={eachFloorTopViewModelRef}
        ref={(node) => {
          topViewModelAllRef.current[lcMapId] = node;
        }}
        position={topviewPosition}
        rotation={[0, 180, 0]}
        scale={[
          floorSize.width / scaleFactor,
          1,
          floorSize.width / scaleFactor,
        ]}
      >
        {isDisplayUI && currentLcMapId == lcMapId ? (
          <GlbModel app={app} url={url} />
        ) : (
          <></>
        )}
      </Entity>
    );
  };

  const FloorTopViewModels = () => {
    const floorAlignments = mapSettingState.floorAlignment;
    const app = useApp();
    const baseUrl = getBaseUrl();
    const floorTopViewImageParentRef = useRef();
    let _previousLcMapId = "x";
    let lastUpdate = 0;
    const UPDATE_INTERVAL = 1 / 2;
    const handleUpdate = useCallback((dt: number) => {
      lastUpdate += dt;
      if (lastUpdate >= UPDATE_INTERVAL) {
        if (_previousLcMapId != currentLcMapIdRef.current) {
          _previousLcMapId = currentLcMapIdRef.current;
          updateFrame();
        }
        lastUpdate = 0;
      }
    }, []);
    useAppEvent("update", handleUpdate);
    const updateFrame = (dt: number) => {
      for (const [key, eachTopView] of Object.entries(
        topViewModelAllRef.current,
      )) {
        if (!eachTopView) {
          continue;
        }
        if (currentLcMapIdRef.current == key) {
          //eachTopView.enabled = true;
          eachTopView.parent.setLocalScale(1, 1, 1);
        } else {
          //eachTopView.enabled = false;
          eachTopView.parent.setLocalScale(0, 0, 0);
        }
      }
    };
    const allFloorTopViewImages = mapSettingRef.current.modelConfig.floor.map(
      (floor, i) => {
        if (floor.topViewModel) {
          const floorSetting = findMapAlignWithLcMapId(
            floorAlignments,
            floor.lcMapId,
          );
          const floorSize = floorSetting.size;
          return (
            <Entity key={floor.lcMapId}>
              <EachFloorTopViewModel
                lcMapId={floor.lcMapId}
                url={
                  baseUrl +
                  mapSettingState.modelConfig.folderPath +
                  floor.topViewModel
                }
                floorSize={floorSize}
                yAxis={floor.yAxis}
              />
            </Entity>
          );
        } else {
          return <Fragment key={floor.lcMapId}></Fragment>;
        }
      },
    );
    return (
      <Entity ref={floorTopViewImageParentRef}>{allFloorTopViewImages}</Entity>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    return (
      <>
        {mapSettingState ? <FloorTopViewModels /> : <></>}
        <VenueSogs />
        <FloorMeshs />
        <Environment exposure={1.0} luminance={0.4} />
        <MainObject />
      </>
    );
  };

  const TopDownScene = () => {
    const isDisplayTopViewScene = useExplorationStore(
      (state) => state.isDisplayTopViewScene,
    );
    return (
      <Application
        usePhysics={false}
        maxDeltaTime={0.033}
        timeScale={1.0}
        graphicsDeviceOptions={{
          powerPreference: "low-power",
          alpha: false,
          antialias: false,
          preferWebGl2: true,
          stencil: false,
        }}
      >
        {mapSettingState != null &&
        mapSettingState.modelConfig != null &&
        isDisplayTopViewScene &&
        mapSettingState.modelConfig != null ? (
          <PlaycanvasScene />
        ) : (
          <></>
        )}
      </Application>
    );
  };

  const DirectionLight = () => {
    const cameraAngle = useExplorationStore((state) => state.cameraAngle);
    return (
      <div
        className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2`}
        style={{ transform: `rotate(${cameraAngle + 180}deg)` }}
      >
        {/*<div className="fixed w-[60px] h-[50px] left-1/2 -translate-x-1/2 -translate-y-full bg-gradient-to-t from-[#FFFFFFDD] to-[#FFFFFF00] [clip-path:polygon(0_0,100%_0,60%_100%,40%_100%)]"></div>*/}
        <div className="fixed w-[80px] left-1/2 -translate-x-1/2 -translate-y-full">
          <img
            src="/assets/spotlight.png"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    );
  };

  const LogoDot = () => {
    const cameraAngle = useExplorationStore((state) => state.cameraAngle);
    return (
      <div style={{ transform: `rotate(${cameraAngle + 180}deg)` }}>
        <img
          src="/assets/icon_logo_dot.png"
          className="w-full h-full object-cover"
        />
      </div>
    );
  };

  return (
    <div
      id="navi-top-view-parent"
      className={`relative hex-crop ${isMobile ? "mobile" : "desktop"} pointer-events-none`}
      style={{
        width: `${HEX_WIDTH_INNER}px`,
        height: `${HEX_HEIGHT_INNER}px`,
      }}
    >
      <div
        className={`relative left-0 bottom-0 h-[100%] w-[100%] transform rotate-180 overflow-hidden`}
      >
        <div
          className={`absolute h-[100%] w-[100%] overflow-hidden bg-black`}
        />

        <div
          id="div-above-canvas"
          className="absolute left-0 bottom-0"
          style={{
            width: `${HEX_WIDTH_INNER}px`,
            height: `${HEX_HEIGHT_INNER}px`,
          }}
        >
          <DataController />
          {!isUnmounting ? <TopDownScene /> : <></>}
        </div>

        <div className="absolute top-1/2 left-1/2 w-[20px] h-[20px] -translate-x-1/2 -translate-y-1/2">
          <DirectionLight />
          <LogoDot />
        </div>
      </div>
    </div>
  );
}
